import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Structure
import { AuthProvider } from 'context/AuthContext';
import { AppProvider } from 'context/AppContext';
import { AppRoutes } from 'routes/AppRoutes';
import { ErrorBoundary } from 'utils/ErrorBoundary';

// Components
import { Modal } from 'components';

// Hooks
import { usePWAInstall } from 'hooks/usePWAInstall';
import { loadHeadData } from 'utils/loadHeadData';

// Styles
import './App.css';
import { GlobalStyle } from 'styles/GlobalStyle';

function App() {
  const { pathname } = useLocation();
  const { isInstalled, handlePwaButton } = usePWAInstall();

  useEffect(() => {
    loadHeadData();
  }, []);

  return (
    <ErrorBoundary>
      <AppProvider>
        <GlobalStyle isLogin={pathname === '/login'} />
        <AuthProvider>
          <Modal />
          <AppRoutes pwaProps={{ isInstalled, handlePwaButton }} />
        </AuthProvider>
      </AppProvider>
    </ErrorBoundary>
  );
}

export default App;
